(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;

    const quantityInputs = cartForm.querySelectorAll('.quantity-input');
    if (!quantityInputs.length) return;

    const submitUpdate = () => {
      // ensure an update action is sent with the form
      if (!cartForm.querySelector('input[name="update"]')) {
        const hiddenUpdate = document.createElement('input');
        hiddenUpdate.type = 'hidden';
        hiddenUpdate.name = 'update';
        hiddenUpdate.value = 'update';
        cartForm.appendChild(hiddenUpdate);
      }
      cartForm.requestSubmit ? cartForm.requestSubmit() : cartForm.submit();
    };

    let timeout;
    quantityInputs.forEach((input) => {
      input.addEventListener('change', () => {
        clearTimeout(timeout);
        timeout = setTimeout(submitUpdate, 150);
      });
      input.addEventListener('input', () => {
        clearTimeout(timeout);
        timeout = setTimeout(submitUpdate, 300);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Navbar scroll effect
  window.addEventListener('scroll', function() {
    const navbar = document.getElementById('navbar');
    if (window.scrollY > 50) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  });

  // Mobile menu toggle
  const mobileMenuButton = document.getElementById('mobile-menu-button');
  const mobileNavMenu = document.getElementById('mobile-nav-menu');
  const mobileNavOverlay = document.getElementById('mobile-nav-overlay');
  const mobileNavClose = document.getElementById('mobile-nav-close');

  function openMobileMenu() {
    mobileMenuButton.classList.add('active');
    mobileNavMenu.classList.add('active');
    mobileNavOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenuButton.classList.remove('active');
    mobileNavMenu.classList.remove('active');
    mobileNavOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  mobileMenuButton.addEventListener('click', openMobileMenu);
  mobileNavClose.addEventListener('click', closeMobileMenu);
  mobileNavOverlay.addEventListener('click', closeMobileMenu);

  // Mobile dropdown toggle
  const mobileNavItems = document.querySelectorAll('.mobile-nav-item.has-dropdown');
  mobileNavItems.forEach(item => {
    const link = item.querySelector('.mobile-nav-link');
    link.addEventListener('click', function(e) {
      e.preventDefault();
      item.classList.toggle('active');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const thumbnails = Array.from(document.querySelectorAll('.product-thumbnail'));
    const mainImage = document.getElementById('product-image-main');
    const prevBtn = document.querySelector('[data-gallery-prev]');
    const nextBtn = document.querySelector('[data-gallery-next]');

    if (!thumbnails.length || !mainImage) return;

    let activeIndex = Math.max(
      thumbnails.findIndex(t => t.classList.contains('active')),
      0
    );

    const setActive = (index) => {
      if (index < 0 || index >= thumbnails.length) return;
      activeIndex = index;

      thumbnails.forEach(t => t.classList.remove('active'));
      const thumb = thumbnails[index];
      thumb.classList.add('active');

      const src = thumb.dataset.image;
      const alt = thumb.dataset.alt || mainImage.getAttribute('alt') || '';

      if (src) {
        mainImage.src = src;
        mainImage.setAttribute('srcset', src);
        mainImage.setAttribute('alt', alt);
      }
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => setActive(index));
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const nextIndex = (activeIndex - 1 + thumbnails.length) % thumbnails.length;
        setActive(nextIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const nextIndex = (activeIndex + 1) % thumbnails.length;
        setActive(nextIndex);
      });
    }

    setActive(activeIndex);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const variantBtns = document.querySelectorAll('.product-variant-btn');
    const hiddenInput = document.getElementById('product-variant');
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const saleBadgeEl = document.querySelector('[data-product-sale-badge]');
    const availabilityEl = document.querySelector('[data-product-availability]');
    const addToCartBtn = document.querySelector('.product-add-to-cart');
    const priceWrapper = document.querySelector('.product-price-wrapper');

    if (!variantBtns.length || !hiddenInput || !priceEl) return;

    variantBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        const price = btn.dataset.price;
        const compareAtPrice = btn.dataset.compareAtPrice;
        const available = btn.dataset.available === 'true';
        const onSale = btn.dataset.onSale === 'true';

        hiddenInput.value = variantId;
        priceEl.textContent = price;

        if (comparePriceEl) {
          if (onSale && compareAtPrice) {
            comparePriceEl.textContent = compareAtPrice;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (saleBadgeEl) {
          saleBadgeEl.style.display = onSale ? '' : 'none';
        }

        if (availabilityEl && priceWrapper) {
          availabilityEl.textContent = available ? priceWrapper.dataset.inStock : priceWrapper.dataset.soldOut;
          availabilityEl.classList.toggle('is-available', available);
          availabilityEl.classList.toggle('is-unavailable', !available);
        }

        if (addToCartBtn) {
          addToCartBtn.disabled = !available;
          addToCartBtn.textContent = available ? addToCartBtn.dataset.addToCartText : addToCartBtn.dataset.soldOutText;
        }

        variantBtns.forEach((b) => {
          b.classList.remove('product-variant-btn--active');
          if (b === btn) b.classList.add('product-variant-btn--active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
